import React from 'react'
import Gauge from 'react-svg-gauge'
import {Col, Row, Button, Badge} from 'reactstrap'
import {TankGauge, ControllerAlarm, ControllerOdometer, ControllerScheduleLabel} from './'

import SetpointIcon from 'react-icons/lib/fa/bullseye'
import WarningIcon from 'react-icons/lib/fa/exclamation-triangle'
import PauseIcon from 'react-icons/lib/fa/pause'
import PlayIcon from 'react-icons/lib/fa/play'
import PencilIcon from 'react-icons/lib/fa/pencil'
import WaterIcon from 'react-icons/lib/io/waterdrop'
import ControllerIcon from 'react-icons/lib/fa/square'

class ControllerGaugeCluster extends React.Component {
    constructor(props) {
        super(props)
        const {controller} = props

        this.state = {
            controller,
            gaugeWidth: 0,
            gaugeHeight: 0,
        }

        this.updateGaugeSize = this.updateGaugeSize.bind(this)
    }

    updateGaugeSize() {
        let col = document.getElementById("first-gauge-cluster-col")
        if (col && col.offsetWidth) {
            let gaugeWidth = col.offsetWidth * 0.9
            let gaugeHeight = gaugeWidth * 0.9
            this.setState({gaugeWidth, gaugeHeight})
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateGaugeSize)
        this.updateGaugeSize()
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateGaugeSize)
    }

    async componentWillReceiveProps(nextProps) {
        let {controller} = nextProps
        await this.setState({controller})
        await this.updateGaugeSize()
    }

    render() {
        let {gaugeWidth, gaugeHeight, controller} = this.state
        return <Col xs={12}>
            <Col xs={12} md={6} className="d-inline-block">
                <Col xs={6} id="first-gauge-cluster-col" className="d-inline-block p-0">
                    <Gauge value={controller.getLatestStatusValue('chemical_rate') || 0}
                           height={gaugeHeight}
                           width={gaugeWidth}
                           topLabelStyle={{transform:"translateY(0.8rem)", fill:"#F88815", fontWeight: "bold",}}
                           minMaxLabelStyle={{fontSize: "0.9rem", transform:"translateY(-0.5rem)"}}
                           min={0}
                           max={controller.maxChemRate}
                           label="Chemical Flow Rate"
                           color="#F88815"/>
                    <p className="gauge-units">{controller.flowUnits || "GPH"}</p>
                    {controller.chemicalNoFlow ?
                        <div>
                            <Badge
                                className="bg-warning alarm-badge pulse"><WarningIcon/>&nbsp;No&nbsp;Chemical&nbsp;Flow</Badge>
                        </div>
                        : null}
                    {controller.chemicalOffRateSetpoint ?
                        <div>
                            <Badge
                                className="bg-warning alarm-badge pulse"><WarningIcon/>&nbsp;Off&nbsp;Rate&nbsp;Setpoint</Badge>
                        </div>
                        : null}
                </Col>
                <Col xs={6} className="d-inline-block p-0">
                    <Gauge value={controller.getLatestStatusValue('chemical_pressure') || 0}
                           height={gaugeHeight}
                           width={gaugeWidth}
                           topLabelStyle={{transform:"translateY(0.8rem)", fill:"#FFAC6C", fontWeight: "bold",}}
                           minMaxLabelStyle={{fontSize: "0.9rem", transform:"translateY(-0.5rem)"}}
                           min={0}
                           max={400}
                           label="Chemical Pressure"
                           color="#FFAC6C"/>
                    <p className="gauge-units">PSI</p>
                    {controller.chemicalHighPressure || controller.chemicalLowPressure ?
                        <Badge
                            className="bg-warning alarm-badge pulse"><WarningIcon/>&nbsp;Chemical&nbsp;Pressure&nbsp;{(controller.chemicalHighPressure ? "High" : "Low")}
                        </Badge>
                        : null}
                </Col>
            </Col>
            <Col xs={12} md={6} className="d-inline-block">
                <Col xs={6} className="d-inline-block p-0">
                    <Gauge value={controller.getLatestStatusValue('water_rate') || 0}
                           height={gaugeHeight}
                           width={gaugeWidth}
                           topLabelStyle={{transform:"translateY(0.8rem)", fill:"#25358D", fontWeight: "bold",}}
                           minMaxLabelStyle={{fontSize: "0.9rem", transform:"translateY(-0.5rem)"}}
                           min={0}
                           max={controller.maxWaterRate}
                           label="Water Flow Rate"
                           color="#25358D"/>
                    <p className="gauge-units">{controller.waterUnits === "L" ? "LPM" : "GPM"}</p>
                    {controller.waterNoFlow ?
                        <Badge className="bg-warning alarm-badge pulse"><WarningIcon/>&nbsp;No&nbsp;Water&nbsp;Flow</Badge>
                        : null}
                </Col>
                <Col xs={6} className="d-inline-block p-0">
                    <Gauge value={controller.getLatestStatusValue('water_pressure') || 0}
                           height={gaugeHeight}
                           width={gaugeWidth}
                           topLabelStyle={{transform:"translateY(0.8rem)", fill:"#6570AC", fontWeight: "bold",}}
                           minMaxLabelStyle={{fontSize: "0.9rem", transform:"translateY(-0.5rem)"}}
                           min={0}
                           max={400}
                           label="Water Pressure"
                           color="#6570AC"/>
                    <p className="gauge-units">PSI</p>
                    {controller.waterHighPressure || controller.waterLowPressure ?
                        <Badge className="bg-warning alarm-badge pulse"><WarningIcon/>&nbsp;Water&nbsp;Pressure&nbsp;{(controller.waterHighPressure ? "High":"Low")}</Badge>
                        : null}
                </Col>
            </Col>
            <Col xs={12} md={6} className="d-inline-block">
                <Col xs={6} className="d-inline-block p-0">
                    <Gauge value={controller.getLatestStatusValue('pwm') || 0}
                           height={gaugeHeight}
                           width={gaugeWidth}
                           topLabelStyle={{transform:"translateY(0.8rem)", fill:"goldenrod", fontWeight: "bold",}}
                           minMaxLabelStyle={{fontSize: "0.9rem", transform:"translateY(-0.5rem)"}}
                           min={0}
                           max={100}
                           label="PWM"
                           color="goldenrod"/>
                    <p className="gauge-units">%</p>
                </Col>
                <Col xs={6} className="d-inline-block p-0">
                    {controller.legacyAccess ? null :
                        <TankGauge tankLevel={controller.getLatestStatusValue('chemical_tank_calculated_level') || 0}
                                   tankLevelUnits={"G"/*controller.batchUnits*/}
                                   tankSize={controller.tankSize}
                                   lowTank={controller.tankIsLow}
                                   width={gaugeWidth * 0.8}
                                   height={gaugeHeight * 0.8}/>}
                </Col>
            </Col>
            <Col xs={12} md={6} className="d-inline-block align-top" style={{minHeight: '200px'}}>
                {controller.getLatestExtendedValue("scheduled_stop_time") && controller.getLatestExtendedValue("scheduled_stop_mode") ?
                    <ControllerScheduleLabel colorClass="bg-danger"
                                       value={controller.scheduledStopTime}>
                        <PauseIcon className="mr-2"/>
                        <span className="d-inline-block d-sm-none">Sched.&nbsp;Stop</span>
                        <span className="d-none d-sm-inline-block">Scheduled&nbsp;Stop&nbsp;at&nbsp;</span>
                    </ControllerScheduleLabel>
                    :null}
                {controller.getLatestExtendedValue("scheduled_start_time") && controller.getLatestExtendedValue("scheduled_start_mode") ?
                    <ControllerScheduleLabel colorClass="bg-success"
                                     value={controller.scheduledStartTime}>
                        <PlayIcon className="mr-2"/>
                        <span className="d-inline-block d-sm-none">Sched.&nbsp;Start</span>
                        <span className="d-none d-sm-inline-block">Scheduled&nbsp;Start&nbsp;at&nbsp;</span>
                    </ControllerScheduleLabel>
                    :null}
                {controller.batchEnable ?
                    <ControllerOdometer colorClass="bg-light-sf-blue"
                                      value={controller.latestExtendedDataPoint.batch_setpoint || 0}
                                      units={controller.batchUnits || "GAL"}>
                        <SetpointIcon className="mr-2 d-none d-sm-inline-block d-md-none d-lg-inline-block"/>
                        Batch&nbsp;Setpoint
                    </ControllerOdometer>
                    : null }
                {controller.batchEnable ?
                    <ControllerOdometer colorClass="bg-light-sf-blue"
                                         value={controller.batchTotal || 0}
                                         units={controller.batchUnits || "GAL"}>
                        <PencilIcon className="mr-2 d-none d-sm-inline-block d-md-none d-lg-inline-block"/>
                        Batch&nbsp;Total
                    </ControllerOdometer>
                    : null }
                <ControllerOdometer colorClass="bg-primary"
                                    value={controller.waterTotalReportingUnits || 0}
                                    units={controller.waterReportingUnitText || "GAL"}>
                    <WaterIcon className="mr-2 d-none d-sm-inline-block d-md-none d-lg-inline-block"/>
                    Water&nbsp;Total
                </ControllerOdometer>
                <ControllerOdometer colorClass="bg-secondary"
                                    value={controller.userTotal || 0}
                                    units={controller.batchUnits || "GAL"}>
                    <ControllerIcon className="mr-2 d-none d-sm-inline-block d-md-none d-lg-inline-block"/>
                    <span className="d-inline-block d-sm-none">Con.&nbsp;Total</span>
                    <span className="d-none d-sm-inline-block">Controller&nbsp;Total</span>
                </ControllerOdometer>
            </Col>
        </Col>
    }
}

export default ControllerGaugeCluster


// WEBPACK FOOTER //
// ./src/components/ui/ControllerGaugeCluster.js